import { render, staticRenderFns } from "./sidebar-yield-controlling.vue?vue&type=template&id=cf8154a2&scoped=true"
import script from "./sidebar-yield-controlling.vue?vue&type=script&lang=js"
export * from "./sidebar-yield-controlling.vue?vue&type=script&lang=js"
import style0 from "./sidebar-yield-controlling.vue?vue&type=style&index=0&id=cf8154a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8154a2",
  null
  
)

export default component.exports